import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import DialPhone from '../../connection/phone';
import { GreenroomState } from '../../stores/types/types';
import Icon, { COLORS, ICONS } from '../general-components/icon';

type DialStatus = 'idle' | 'dialing' | 'error';

const PhoneDialer: React.FC = () => {
	const [phoneNumber, setPhoneNumber] = useState('');
	const [status, setStatus] = useState<DialStatus>('idle');
	const [errorMessage, setErrorMessage] = useState('');

	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const user = useSelector((state: GreenroomState) => state.SessionReducer.user);
	const meetingId = useSelector(
		(state: GreenroomState) => state.SessionReducer.meeting?.meeting_id,
	);

	const callerName = user
		? [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email
		: '';

	const handleDial = async () => {
		if (!phoneNumber.trim() || !token || !meetingId || status === 'dialing') return;

		setStatus('dialing');
		setErrorMessage('');

		const result = await DialPhone(token, phoneNumber.trim(), meetingId);

		if (result?.message) {
			setStatus('error');
			setErrorMessage(result.message);
		} else {
			setStatus('idle');
			setPhoneNumber('');
		}
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') handleDial();
	};

	return (
		<div className="phone-dialer">
			<div className="phone-dialer__header">
				<Icon name={ICONS.PHONE} size={14} color={COLORS.WHITE} />
				<span className="phone-dialer__label">Dial Phone</span>
				{callerName && (
					<span className="phone-dialer__caller" title={callerName}>
						{callerName}
					</span>
				)}
			</div>
			<div className="phone-dialer__row">
				<input
					className="phone-dialer__input dark-input-container"
					type="tel"
					placeholder="+1 555 000 0000"
					value={phoneNumber}
					onChange={(e) => setPhoneNumber(e.target.value)}
					onKeyDown={handleKeyDown}
					disabled={status === 'dialing'}
				/>
				<button
					className="phone-dialer__button"
					onClick={handleDial}
					disabled={status === 'dialing' || !phoneNumber.trim()}
				>
					{status === 'dialing' ? 'Dialing…' : 'Call'}
				</button>
			</div>
			{status === 'error' && (
				<span className="phone-dialer__error">{errorMessage}</span>
			)}
		</div>
	);
};

export default PhoneDialer;
